import { render, staticRenderFns } from "./QuoteType2.vue?vue&type=template&id=fa42c852&scoped=true&"
import script from "./QuoteType2.vue?vue&type=script&lang=js&"
export * from "./QuoteType2.vue?vue&type=script&lang=js&"
import style0 from "./QuoteType2.vue?vue&type=style&index=0&id=fa42c852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa42c852",
  null
  
)

export default component.exports